import {
  ChartColumn,
  House,
  ListOrdered,
  type LucideIcon,
  Repeat,
  Settings,
  ShieldCheck,
  Tag,
  Target,
  Wallet,
} from "lucide-react";

export type NavItem = { to: string; label: string; Icon: LucideIcon; end?: boolean };

export const NAV: NavItem[] = [
  { to: "", label: "Início", Icon: House, end: true },
  { to: "transactions", label: "Lançamentos", Icon: ListOrdered },
  { to: "accounts", label: "Contas", Icon: Wallet },
  { to: "categories", label: "Categorias", Icon: Tag },
  { to: "budgets", label: "Orçamentos", Icon: Target },
  { to: "recurrences", label: "Recorrências", Icon: Repeat },
  { to: "reports", label: "Relatórios", Icon: ChartColumn },
  { to: "settings", label: "Configurações", Icon: Settings },
];

/** Administração da plataforma: só para fundadores. */
export const ADMIN_ITEM: NavItem = { to: "admin", label: "Administração", Icon: ShieldCheck };

export function navItems(platformAdmin: boolean): NavItem[] {
  return platformAdmin ? [...NAV, ADMIN_ITEM] : NAV;
}

/** Destinos fixos na barra inferior do celular; o resto vai para "Mais". */
export const BOTTOM = new Set(["", "transactions", "budgets"]);
